import comp from './Loading';
export default comp;
